import { createApp } from "vue";
import { Quasar } from "quasar";
import axios from "axios";
import YouTube from "vue3-youtube";

import App from "@/App.vue";
import router from "@/router/router";
import store from "@/store/store";
import quasarOptions, { manterDialogosNaTrocaDeRota, destravarFocoDosTooltips } from "@/quasar/quasar";
import mixinGlobal from "@/mixins/mixins";
import { instalarFormatters } from "@/plugins/formatters";
import { registrarGlobais } from "@/components/_globals";
import { initSentry } from "@/sentry";
import { instalarTratadorDeErros } from "@/plugins/erros-vue";

axios.defaults.baseURL = process.env.VUE_APP_URL_API;

const app = createApp(App);

// Before mount, so that bootstrap errors are captured too.
initSentry(app, router);

// Log render/hook/watcher errors and keep going, as Vue 2 did (see erros-vue.js). After
// initSentry: it wraps Sentry's handler, so Sentry still reports them as unhandled.
instalarTratadorDeErros(app);

app.use(Quasar, quasarOptions);
manterDialogosNaTrocaDeRota(app);
destravarFocoDosTooltips();
app.use(store);
app.use(router);
app.mixin(mixinGlobal);
instalarFormatters(app);
registrarGlobais(app);

// `Vue.use(VueYoutube)` used to register <youtube> globally, and that is how its
// three call sites find it. Registering it locally does not work for all of them:
// modal-manuais.vue has no `components` block at all.
app.component("youtube", YouTube);

if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line no-console
  console.log("Modo " + process.env.NODE_ENV + ": " + process.env.VUE_APP_URL_API);
}

app.mount("#app");

// The service worker carries the Web Push handlers and caches nothing (see
// public/service-worker.js). Production only, as with the Vue CLI PWA plugin: in dev
// a worker would outlive the dev server and serve nothing useful.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Rejects where workers are off (Firefox private windows, some policies); there is
    // no push on that browser then, and nothing else depends on the worker.
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
